import logotxt from '../Images/logo_txt_crop.png'
import MenuBar from './MenuBar'

function Banner(){
    return(
        <div className="row">
            <div className="col-md-4 text-center align-self-center">
        <a href="/">
            <img className="logoimg" src={logotxt} alt="" href="/" ></img>
        </a>
        </div>
        <div className="col-md-8 text-center align-self-center">

        <MenuBar/>
        </div>
        </div>
    )
}

export default Banner;